function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 1C5.47301 1 1 5.47254 1 11C1 16.527 5.47254 21 11 21C16.527 21 21 16.5275 21 11C21 5.47301 16.5275 1 11 1ZM11 19.6667C6.22121 19.6667 2.33332 15.7788 2.33332 11C2.33332 6.22117 6.22121 2.33332 11 2.33332C15.7788 2.33332 19.6667 6.22121 19.6667 11C19.6667 15.7788 15.7788 19.6667 11 19.6667Z",
  fill: "currentColor"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.576 8.16534L6.15003 9.20813C5.53317 9.27627 5.33686 10.0814 5.85384 10.4257L9.11761 12.5991L9.36794 16.5123C9.40792 17.1369 10.2058 17.3607 10.5705 16.8645L16.1865 9.22284C16.53 8.75534 16.1514 8.10168 15.576 8.16534ZM10.5815 14.5978L10.4271 12.1845C10.4138 11.9769 10.3044 11.7875 10.1313 11.6722L8.11852 10.3318L14.2121 9.65768L10.5815 14.5978Z",
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11 1C5.47301 1 1 5.47254 1 11C1 16.527 5.47254 21 11 21C16.527 21 21 16.5275 21 11C21 5.47301 16.5275 1 11 1ZM11 19.6667C6.22121 19.6667 2.33332 15.7788 2.33332 11C2.33332 6.22117 6.22121 2.33332 11 2.33332C15.7788 2.33332 19.6667 6.22121 19.6667 11C19.6667 15.7788 15.7788 19.6667 11 19.6667Z",
  stroke: "currentColor",
  strokeWidth: 0.2
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.576 8.16534L6.15003 9.20813C5.53317 9.27627 5.33686 10.0814 5.85384 10.4257L9.11761 12.5991L9.36794 16.5123C9.40792 17.1369 10.2058 17.3607 10.5705 16.8645L16.1865 9.22284C16.53 8.75534 16.1514 8.10168 15.576 8.16534ZM10.5815 14.5978L10.4271 12.1845C10.4138 11.9769 10.3044 11.7875 10.1313 11.6722L8.11852 10.3318L14.2121 9.65768L10.5815 14.5978Z",
  stroke: "currentColor",
  strokeWidth: 0.2
});
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.6f83a448b3d4beb113c2446541170ed7.svg";
export { ForwardRef as ReactComponent };